heroHandler = {
    $panelHero: $('.panel-hero'),
    $galleryContainer: $('.panel-hero').find('.gallery-hero'),

    init: function() {
        var self = this;

        $(window).on('resize', function() {
            $heroImage = $('body').find('.hero-image-resize');

            $heroImage.each(function(){
                var width = $(this).width();
                var newHeight = (width / 16) * 9;

                $(this).height(newHeight);
            })
        });

        $gallery = self.$galleryContainer.flickity({
            prevNextButtons: false,
            wrapAround: true,
            pageDots: true,
            adaptiveHeight: true,
            fullscreen: false,
            prevNextButtons: false,
            autoPlay: 3000,
            pauseAutoPlayOnHover: false,
            imagesLoaded: true,
            fade: true
        })

        self.$panelHero.find('.flickity-page-dots').append('<span class="btn-play-pause fa fa-pause pause-carousel"></span>')
        
        $('body').on('click', '.pause-carousel', function() {
            $gallery.flickity('stopPlayer')
            $(this).toggleClass('pause-carousel play-carousel fa-pause fa-play')
        })

        $('body').on('click', '.play-carousel', function() {
            $gallery.flickity('playPlayer')
            $(this).toggleClass('pause-carousel play-carousel fa-pause fa-play')
        })
        
    }
}